import React, { useState } from 'react';
import InteractiveText from './InteractiveText';
import { getSpanishMeaning } from '../utils/dictionaryHelper';

// 📚 BASE DE DATOS COMPLETA DE REGLAS Y GUÍAS GRAMATICALES POR GRADO Y UNIDAD
export const GRAMMAR_DATABASE = {
  '6': {
    1: {
      title: 'Unidad 1: Saludos, Datos Personales y Verbo TO BE',
      subtitle: 'Fundamentos de Presente Simple con el verbo Ser o Estar',
      topics: [
        {
          name: 'Verbo TO BE (Presente Simple)',
          rule: 'El verbo TO BE significa "ser" o "estar". Se conjuga de tres formas en presente: AM, IS, ARE según el sujeto.',
          formula: 'Sujeto + AM / IS / ARE + Complemento',
          conjugation: [
            { subject: 'I (Yo)', form: 'am', example: 'I am a student at IE EOH.', translation: 'Yo soy un estudiante en la IE EOH.' },
            { subject: 'He / She / It (Él / Ella / Eso)', form: 'is', example: 'She is 11 years old.', translation: 'Ella tiene 11 años de edad.' },
            { subject: 'We / You / They (Nosotros / Tú / Ellos)', form: 'are', example: 'They are in the classroom.', translation: 'Ellos están en el salón de clases.' }
          ],
          structures: [
            { type: 'Afirmativa (+)', pattern: 'Subject + BE + Complement', example: 'Carlos is from Medellín.' },
            { type: 'Negativa (-)', pattern: 'Subject + BE + NOT + Complement', example: 'Carlos is not (isn\'t) from Bogotá.' },
            { type: 'Interrogativa (?)', pattern: 'BE + Subject + Complement + ?', example: 'Is Carlos from Medellín? -> Yes, he is.' }
          ],
          icfesTip: 'En las preguntas de Pruebas Saber ICFES, "I" SIEMPRE se acompaña de "am". NUNCA digas "I is" ni "I are".'
        },
        {
          name: 'Alfabeto, Números (1-100) y Deletreo',
          rule: 'Para responder a "How do you spell...?" debemos nombrar las letras en inglés una a una.',
          formula: 'How do you spell + [Palabra] + ?',
          examples: [
            { english: 'How do you spell your name? -> M - A - T - E - O', spanish: '¿Cómo deletreas tu nombre? -> M - A - T - E - O' },
            { english: 'fifteen (15) vs. fifty (50)', spanish: '15 se escribe fifteen / 50 se escribe fifty' }
          ],
          icfesTip: 'En la Parte 1 de los avisos del ICFES, las horas y números suelen escribirse en letras. Repasa la diferencia entre -teen (13-19) y -ty (20-90).'
        }
      ]
    },
    2: {
      title: 'Unidad 2: La Familia, La Casa y Posesivos',
      subtitle: 'Adjetivos Posesivos y Vocabulario de la Casa',
      topics: [
        {
          name: 'Adjetivos Posesivos (Possessive Adjectives)',
          rule: 'Indican a quién pertenece un objeto o quién es el familiar. Se colocan ANTES del sustantivo.',
          formula: 'Adjetivo Posesivo + Sustantivo',
          conjugation: [
            { subject: 'I (Yo)', form: 'MY', example: 'My name is Mateo.', translation: 'Mi nombre es Mateo.' },
            { subject: 'He (Él)', form: 'HIS', example: 'His sister is Sofia.', translation: 'Su hermana (de él) es Sofia.' },
            { subject: 'She (Ella)', form: 'HER', example: 'Her house is big.', translation: 'Su casa (de ella) es grande.' },
            { subject: 'We (Nosotros)', form: 'OUR', example: 'Our teacher is Mr. Didier.', translation: 'Nuestro profesor es el Prof. Didier.' },
            { subject: 'They (Ellos)', form: 'THEIR', example: 'Their garden is beautiful.', translation: 'Su jardín (de ellos) es hermoso.' }
          ],
          structures: [
            { type: 'Uso de HIS (de él)', pattern: 'Male Subject -> HIS', example: 'David lives with his parents.' },
            { type: 'Uso de HER (de ella)', pattern: 'Female Subject -> HER', example: 'Lucia loves her grandfather.' }
          ],
          icfesTip: 'Confusión muy común en el ICFES: Usar "his" para referirse a una mujer. Recuerda: HIS = de él (varón), HER = de ella (mujer).'
        },
        {
          name: 'Habitaciones de la Casa y Preposición IN',
          rule: 'Para indicar en qué habitación de la casa se encuentra alguien, usamos la preposición IN.',
          formula: 'Subject + BE + in the + [Habitación]',
          examples: [
            { english: 'My mother is in the kitchen.', spanish: 'Mi madre está en la cocina.' },
            { english: 'The bed is in the bedroom.', spanish: 'La cama está en el dormitorio.' }
          ],
          icfesTip: 'Kitchen = Cocina / Chicken = Pollo. ¡Atención a la ortografía en preguntas de vocabulario!'
        }
      ]
    },
    3: {
      title: 'Unidad 3: Rutinas Diarias y Presente Simple',
      subtitle: 'Estructura para hablar de hábitos, horarios y acciones cotidianas',
      topics: [
        {
          name: 'Presente Simple (Present Simple Tense)',
          rule: 'Se usa para expresar rutinas, hábitos y verdades generales. En tercera persona (He, She, It) agregamos -s o -es al verbo.',
          formula: 'Sujeto + Verbo (-s/-es en 3ª persona) + Complemento',
          conjugation: [
            { subject: 'I / You / We / They', form: 'Verbo normal', example: 'I study English every day.', translation: 'Yo estudio inglés todos los días.' },
            { subject: 'He / She / It', form: 'Verbo + -s / -es', example: 'She studies English at IE EOH.', translation: 'Ella estudia inglés en la IE EOH.' }
          ],
          structures: [
            { type: 'Afirmativa (+)', pattern: 'Subject + Verb(-s) + Complement', example: 'He plays football on Fridays.' },
            { type: 'Negativa (-)', pattern: 'Subject + DON\'T / DOESN\'T + Verb (base)', example: 'She doesn\'t play football.' },
            { type: 'Interrogativa (?)', pattern: 'DO / DOES + Subject + Verb (base) + ?', example: 'Does he study at IE EOH? -> Yes, he does.' }
          ],
          icfesTip: 'Cuando usas el auxiliar DOES o DOESN\'T en preguntas y negativas, el verbo principal VUELVE a su forma normal sin "s". Ej: "She doesn\'t LIKE" (NO: doesn\'t likes).'
        }
      ]
    },
    4: {
      title: 'Unidad 4: Materias Escolares y Verbo Modal CAN',
      subtitle: 'Expresar Habilidades, Permisos y Reglas en el Salón',
      topics: [
        {
          name: 'Verbo Modal CAN / CANNOT (Poder / Habilidad)',
          rule: 'CAN expresa habilidad física o intelectual, o permiso. NUNCA cambia en tercera persona ni lleva "to".',
          formula: 'Sujeto + CAN / CANNOT (CAN\'T) + Verbo en forma base',
          examples: [
            { english: 'I can speak English.', spanish: 'Puedo hablar inglés (Tengo la habilidad).' },
            { english: 'She can\'t use her phone in class.', spanish: 'Ella no puede usar su teléfono en clase (No tiene permiso).' },
            { english: 'Can you help me with the exercises?', spanish: '¿Puedes ayudarme con los ejercicios?' }
          ],
          icfesTip: 'Después de CAN el verbo va en infinitivo SIN "to". Decir "I can to play" es INCORRECTO. Lo correcto es: "I can play".'
        }
      ]
    },
    5: {
      title: 'Unidad 5: Tiempo Libre, Gustos y Preposiciones de Lugar',
      subtitle: 'Expresar preferencias (Like + -ing) y ubicación exacta',
      topics: [
        {
          name: 'Expresar Gustos (LIKE / LOVE / HATE + Verbo -ING)',
          rule: 'Cuando usamos verbos de preferencia como LIKE, LOVE o HATE seguidos de otra acción, el segundo verbo lleva la terminación -ING.',
          formula: 'Subject + LIKE / LOVE / HATE + Verbo-ING',
          examples: [
            { english: 'I like reading books in English.', spanish: 'Me gusta leer libros en inglés.' },
            { english: 'Sofia loves swimming on weekends.', spanish: 'A Sofia le encanta nadar los fines de semana.' }
          ],
          icfesTip: 'En preguntas del ICFES Parte 4 (Completar espacios), si ves "like" seguido de un espacio de verbo, busca la opción que termine en -ING.'
        },
        {
          name: 'Preposiciones de Lugar (IN, ON, AT, UNDER)',
          rule: 'IN = dentro de un espacio cerrado / ON = sobre una superficie / AT = en un punto o lugar específico / UNDER = debajo de.',
          formula: 'Preposición + Sustantivo',
          examples: [
            { english: 'The book is ON the table.', spanish: 'El libro está SOBRE la mesa.' },
            { english: 'We are AT school right now.', spanish: 'Estamos EN el colegio en este momento.' }
          ],
          icfesTip: 'ON the table (sobre la mesa), IN the box (dentro de la caja), AT the entrance (en la entrada).'
        }
      ]
    }
  },
  '7': {
    1: {
      title: 'Unidad 1: Presente Continuo (Present Continuous)',
      subtitle: 'Acciones que están ocurriendo en este mismo momento',
      topics: [
        {
          name: 'Presente Continuo (Present Continuous Tense)',
          rule: 'Se usa para describir acciones en progreso inmediato. Se forma con el verbo TO BE (am/is/are) + el verbo principal terminado en -ING.',
          formula: 'Sujeto + AM / IS / ARE + Verbo-ING + Complemento',
          conjugation: [
            { subject: 'I', form: 'am working', example: 'I am practicing English right now.', translation: 'Estoy practicando inglés en este momento.' },
            { subject: 'He / She', form: 'is reading', example: 'She is reading a story.', translation: 'Ella está leyendo una historia.' },
            { subject: 'We / They', form: 'are studying', example: 'They are studying for the test.', translation: 'Ellos están estudiando para el examen.' }
          ],
          structures: [
            { type: 'Afirmativa (+)', pattern: 'Subject + BE + Verb-ING', example: 'The teacher is explaining the grammar rule.' },
            { type: 'Negativa (-)', pattern: 'Subject + BE + NOT + Verb-ING', example: 'We are not (aren\'t) playing games right now.' },
            { type: 'Interrogativa (?)', pattern: 'BE + Subject + Verb-ING + ?', example: 'Are you listening to the teacher? -> Yes, I am.' }
          ],
          icfesTip: 'Expresiones clave que activan el Presente Continuo en textos del ICFES: "right now", "at the moment", "look!", "listen!".'
        }
      ]
    },
    2: {
      title: 'Unidad 2: Sustantivos Contables, Incontables y Cuantificadores',
      subtitle: 'Uso de SOME, ANY, MUCH, MANY y A LOT OF',
      topics: [
        {
          name: 'Sustantivos Contables vs. Incontables',
          rule: 'Contables: Se pueden contar en unidades (1 apple, 2 apples). Incontables: No se dividen individualmente (water, money, sugar, information).',
          formula: 'MANY / FEW (Contables) vs. MUCH / LITTLE (Incontables)',
          examples: [
            { english: 'How many students are in 701? (Contable)', spanish: '¿Cuántos estudiantes hay en 701?' },
            { english: 'How much water do you drink? (Incontable)', spanish: '¿Mucha agua bebes?' }
          ],
          icfesTip: 'SOME se usa en oraciones AFIRMATIVAS. ANY se usa en oraciones NEGATIVAS y PREGUNTAS. Ej: "I have SOME books / I don\'t have ANY books".'
        }
      ]
    },
    3: {
      title: 'Unidad 3: Pasado Simple del Verbo TO BE y Verbos Regulares',
      subtitle: 'Describir estados y acciones completadas en el pasado',
      topics: [
        {
          name: 'Pasado Simple del Verbo TO BE (WAS / WERE)',
          rule: 'WAS es el pasado de AM / IS (para I, He, She, It). WERE es el pasado de ARE (para We, You, They).',
          formula: 'Sujeto + WAS / WERE + Complemento',
          conjugation: [
            { subject: 'I / He / She / It', form: 'WAS', example: 'I was at school yesterday.', translation: 'Yo estaba en el colegio ayer.' },
            { subject: 'We / You / They', form: 'WERE', example: 'We were happy with the results.', translation: 'Estábamos felices con los resultados.' }
          ],
          icfesTip: 'Yesterday (ayer), last week (la semana pasada) y in 2025 indican que debes seleccionar WAS o WERE.'
        },
        {
          name: 'Verbos Regulares en Pasado (-ED)',
          rule: 'Para la mayoría de los verbos regulares, agregamos -ED al final para formar el pasado simple.',
          formula: 'Sujeto + Verbo-ED + Complemento',
          examples: [
            { english: 'played (jugué/jugó)', spanish: 'play -> played (I played football yesterday).' },
            { english: 'studied (estudié/estudió)', spanish: 'study -> studied (She studied English last night).' }
          ],
          icfesTip: 'Si el verbo termina en consonante + y, se cambia la y por ied: study -> studied.'
        }
      ]
    },
    4: {
      title: 'Unidad 4: Verbos Irregulares en Pasado y Preguntas con DID',
      subtitle: 'Dominio de los verbos cambiantes en el pasado',
      topics: [
        {
          name: 'Verbos Irregulares y Auxiliar DID',
          rule: 'Los verbos irregulares no llevan -ed, cambian su forma (go -> went, see -> saw). Para negar o preguntar en pasado usamos el auxiliar DID.',
          formula: 'Pregunta: DID + Sujeto + Verbo (base) + ?',
          examples: [
            { english: 'go -> went / see -> saw / write -> wrote', spanish: 'Ir -> fui / Ver -> vi / Escribir -> escribí' },
            { english: 'Did you see the announcement? -> Yes, I did.', spanish: '¿Viste el aviso? -> Sí, lo vi.' },
            { english: 'I didn\'t go to the park yesterday.', spanish: 'No fui al parque ayer.' }
          ],
          icfesTip: 'Recuerda: Cuando usas DIDN\'T o DID en la frase, el verbo principal VUELVE a su forma presente/base. Ej: "I didn\'t GO" (NO: didn\'t went).'
        }
      ]
    },
    5: {
      title: 'Unidad 5: Adjetivos Comparativos y Superlativos',
      subtitle: 'Comparar dos o más elementos en inglés',
      topics: [
        {
          name: 'Comparativos (-ER THAN / MORE ... THAN)',
          rule: 'Para comparar 2 cosas: Adjetivos cortos agregamos -ER THAN (fast -> faster than). Adjetivos largos usamos MORE ... THAN (more interesting than).',
          formula: 'Adjetivo corto + -ER THAN  |  MORE + Adjetivo largo + THAN',
          examples: [
            { english: 'Medellín is bigger than Envigado.', spanish: 'Medellín es más grande que Envigado.' },
            { english: 'English is more interesting than math.', spanish: 'El inglés es más interesante que la matemática.' }
          ],
          icfesTip: 'NUNCA combines "more" con "-er". Decir "more bigger" es un error grave. Di únicamente "bigger than".'
        }
      ]
    }
  },
  '9': {
    1: {
      title: 'Unidad 1: Presente Perfecto (Present Perfect Tense)',
      subtitle: 'Experiencias de vida y acciones pasadas con relevancia actual',
      topics: [
        {
          name: 'Presente Perfecto (HAVE / HAS + Participio Pasado)',
          rule: 'Se utiliza para hablar de experiencias de vida sin especificar el momento exacto, o acciones que comenzaron en el pasado y continúan.',
          formula: 'Sujeto + HAVE / HAS + Verbo en Participio Pasado (V3)',
          conjugation: [
            { subject: 'I / You / We / They', form: 'HAVE + V3', example: 'I have visited San Andrés twice.', translation: 'He visitado San Andrés dos veces.' },
            { subject: 'He / She / It', form: 'HAS + V3', example: 'She has completed 5 units.', translation: 'Ella ha completado 5 unidades.' }
          ],
          structures: [
            { type: 'Uso de EVER (¿Alguna vez?)', pattern: 'Have you EVER + V3 + ?', example: 'Have you ever traveled abroad?' },
            { type: 'Uso de NEVER (Nunca)', pattern: 'Subject + HAS/HAVE NEVER + V3', example: 'I have never failed an English test.' }
          ],
          icfesTip: 'En preguntas del ICFES Parte 5 y 6 (Lectura Crítica), "ever" se usa en preguntas y "never" en oraciones afirmativas con sentido negativo.'
        }
      ]
    },
    2: {
      title: 'Unidad 2: Pasado Continuo vs. Pasado Simple (WHEN / WHILE)',
      subtitle: 'Acciones en progreso interrumpidas por otro evento en el pasado',
      topics: [
        {
          name: 'Interrupción de Acciones (WAS/WERE -ING + WHEN + Past Simple)',
          rule: 'El Pasado Continuo (was/were + -ing) describe una acción larga en progreso. El Pasado Simple (verb-ed / irregular) indica la acción corta que interrumpe.',
          formula: 'Pasado Continuo + WHEN + Pasado Simple',
          examples: [
            { english: 'I was studying English WHEN the phone rang.', spanish: 'Estaba estudiando inglés CUANDO sonó el teléfono.' },
            { english: 'WHILE we were playing, it started to rain.', spanish: 'MIENTRAS estábamos jugando, comenzó a llover.' }
          ],
          icfesTip: 'Regla de oro ICFES: "WHEN" introduce Pasado Simple (acción corta). "WHILE" introduce Pasado Continuo (acción larga en progreso).'
        }
      ]
    },
    3: {
      title: 'Unidad 3: Expresar Futuro: WILL vs. BE GOING TO',
      subtitle: 'Diferencia entre predicciones espontáneas y planes estructurados',
      topics: [
        {
          name: 'WILL vs. BE GOING TO',
          rule: 'WILL = Decisiones espontáneas, promesas o predicciones basadas en opinión. BE GOING TO = Planes ya organizados, intenciones claras o evidencia presente.',
          formula: 'WILL + Verbo  vs.  AM/IS/ARE GOING TO + Verbo',
          examples: [
            { english: 'I will help you with your homework. (Espontáneo)', spanish: 'Te ayudaré con tu tarea (Ofrecimiento en el instante).' },
            { english: 'I am going to study Medicine next year. (Plan previo)', spanish: 'Voy a estudiar Medicina el próximo año (Plan decidido).' }
          ],
          icfesTip: 'En textos sobre proyectos de vida o metas académicas futuras, "going to" indica un plan ya diseñado por el estudiante.'
        }
      ]
    },
    4: {
      title: 'Unidad 4: Primer Condicional (First Conditional)',
      subtitle: 'Causa y efecto sobre situaciones reales y probables del futuro',
      topics: [
        {
          name: 'Primer Condicional (If + Present Simple, Will + Verb)',
          rule: 'Expresa una condición real presente y su consecuencia futura probable. La cláusula con IF siempre va en Presente Simple.',
          formula: 'IF + Present Simple  --->  Future Simple (WILL + Verbo)',
          examples: [
            { english: 'If you study daily, you will pass the ICFES test.', spanish: 'Si estudias a diario, pasarás la prueba ICFES.' },
            { english: 'If it rains tomorrow, we will stay inside.', spanish: 'Si llueve mañana, nos quedaremos adentro.' }
          ],
          icfesTip: '¡Cuidado en el examen! NUNCA pongas "WILL" inmediatamente después de "IF". Lo correcto es: "If it RAINS, we WILL go".'
        }
      ]
    },
    5: {
      title: 'Unidad 5: Verbos Modales y Lectura Crítica ICFES',
      subtitle: 'Expresar Obligación, Recomendación y Permiso en Pruebas Saber',
      topics: [
        {
          name: 'Verbos Modales (MUST, SHOULD, HAVE TO, MAY)',
          rule: 'MUST / HAVE TO = Obligación o norma estricta. SHOULD = Consejo o sugerencia. MAY / MIGHT = Posibilidad o permiso educado.',
          formula: 'Sujeto + Modal + Verbo base (sin to)',
          examples: [
            { english: 'Students MUST wear the uniform. (Obligación)', spanish: 'Los estudiantes deben usar el uniforme.' },
            { english: 'You SHOULD read carefully before answering. (Consejo)', spanish: 'Deberías leer con cuidado antes de responder.' },
            { english: 'You MAY ask a question now. (Permiso)', spanish: 'Puedes hacer una pregunta ahora.' }
          ],
          icfesTip: 'En los avisos de la Parte 1 del ICFES: "MUST" se usa para letreros de seguridad y normas escolares. "SHOULD" para recomendaciones.'
        }
      ]
    }
  }
};

export default function GrammarHub() {
  const [selectedGrade, setSelectedGrade] = useState('6');
  const [selectedUnit, setSelectedUnit] = useState(1);
  const [activeWordData, setActiveWordData] = useState(null);

  const handleWordClick = async (cleanWord) => {
    const data = await getSpanishMeaning(cleanWord);
    setActiveWordData(data);
  };

  const currentGuide = GRAMMAR_DATABASE[selectedGrade]?.[selectedUnit] || GRAMMAR_DATABASE['6'][1];

  return (
    <div className="space-y-6 text-slate-100 animate-fadeIn">
      
      {/* ENCABEZADO PRINCIPAL DEL CENTRO DE GRAMÁTICA */}
      <div className="bg-gradient-to-r from-blue-900 via-slate-900 to-indigo-950 border border-blue-500/40 p-6 md:p-8 rounded-3xl shadow-2xl space-y-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <span className="text-[10px] font-extrabold uppercase tracking-widest text-blue-300 bg-blue-950 px-3 py-1 rounded-full border border-blue-500/40">
              Repositorio de Reglas & Fórmulas Gramaticales
            </span>
            <h2 className="text-2xl md:text-3xl font-black text-white mt-2 flex items-center gap-2">
              <span>📖</span> Guías Gramaticales por Unidad (Grados 6°, 7° y 9°)
            </h2>
            <p className="text-xs md:text-sm text-slate-300 mt-1 max-w-2xl">
              Revisa las estructuras, fórmulas, conjugaciones, ejemplos bilingües y tips clave para arrasar en tus tareas y Pruebas Saber ICFES.
            </p>
          </div>
        </div>

        {/* CONTROLES DE SELECCIÓN DE GRADO Y UNIDAD */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 border-t border-slate-800">
          <div>
            <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">
              1. Seleccionar Grado Académico:
            </label>
            <select
              value={selectedGrade}
              onChange={(e) => setSelectedGrade(e.target.value)}
              className="w-full bg-slate-950 border border-blue-500/50 rounded-xl px-4 py-3 text-xs font-bold text-white outline-none focus:border-blue-400 transition cursor-pointer"
            >
              <option value="6">Grado 6° — Fundamentos (Verb To Be, Present Simple, Can)</option>
              <option value="7">Grado 7° — Task-Based Learning (Present Continuous, Past Simple, Comparatives)</option>
              <option value="9">Grado 9° — Competencias Avanzadas ICFES (Present Perfect, Conditionals, Modals)</option>
            </select>
          </div>

          <div>
            <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">
              2. Seleccionar Unidad Temática:
            </label>
            <div className="grid grid-cols-5 gap-1.5">
              {[1, 2, 3, 4, 5].map((uNum) => (
                <button
                  key={uNum}
                  onClick={() => setSelectedUnit(uNum)}
                  className={`py-2.5 rounded-xl text-xs font-extrabold transition cursor-pointer border ${
                    selectedUnit === uNum
                      ? 'bg-blue-600 border-blue-400 text-white shadow-lg scale-105'
                      : 'bg-slate-950 border-slate-800 text-slate-400 hover:text-white hover:bg-slate-800'
                  }`}
                >
                  U{uNum}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* GUÍA DETALLADA DE LA UNIDAD SELECCIONADA */}
      <div className="bg-slate-900/90 border border-slate-800 p-6 md:p-8 rounded-3xl space-y-8 shadow-2xl">
        
        <div className="border-b border-slate-800 pb-4">
          <span className="text-[11px] font-extrabold uppercase tracking-widest text-emerald-400">
            Grado {selectedGrade}° — Unidad {selectedUnit}
          </span>
          <h3 className="text-xl md:text-2xl font-black text-white mt-1">
            {currentGuide.title}
          </h3>
          <p className="text-xs text-slate-400 mt-1">
            {currentGuide.subtitle}
          </p>
        </div>

        {/* LISTADO DE TEMAS DE LA UNIDAD */}
        <div className="space-y-8">
          {currentGuide.topics.map((topic, idx) => (
            <div key={idx} className="bg-slate-950 border border-slate-800 p-6 rounded-2xl space-y-5 shadow-lg relative overflow-hidden">
              
              <div className="flex items-center gap-3">
                <span className="bg-blue-950 border border-blue-500/40 text-blue-300 text-xs font-black w-7 h-7 rounded-full flex items-center justify-center shrink-0">
                  {idx + 1}
                </span>
                <h4 className="text-lg font-black text-white">
                  {topic.name}
                </h4>
              </div>

              {/* REGLA Y FÓRMULA ESTRUCTURAL */}
              <div className="space-y-3">
                <div className="bg-slate-900 p-4 rounded-xl border border-slate-800 text-xs leading-relaxed text-slate-200">
                  <strong className="text-blue-400 block mb-1 uppercase tracking-wider text-[10px]">📌 Regla Explicativa:</strong>
                  <InteractiveText text={topic.rule} onWordClick={handleWordClick} />
                </div>

                {topic.formula && (
                  <div className="bg-blue-950/80 border border-blue-500/50 p-4 rounded-xl text-center space-y-1">
                    <span className="text-[10px] font-extrabold uppercase tracking-widest text-blue-300 block">⚡ Fórmula de Estructura:</span>
                    <div className="text-sm md:text-base font-black font-mono text-emerald-300 tracking-wide">
                      {topic.formula}
                    </div>
                  </div>
                )}
              </div>

              {/* TABLA DE CONJUGACIÓN (SI APLICA) */}
              {topic.conjugation && (
                <div className="space-y-2">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block">📊 Tabla de Conjugación & Ejemplos:</span>
                  <div className="overflow-x-auto">
                    <table className="w-full text-left text-xs border-collapse">
                      <thead>
                        <tr className="bg-slate-900 text-slate-400 uppercase text-[10px] border-b border-slate-800">
                          <th className="p-3">Sujeto</th>
                          <th className="p-3">Forma Gramatical</th>
                          <th className="p-3">Ejemplo en Inglés</th>
                          <th className="p-3">Traducción al Español</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-800/60">
                        {topic.conjugation.map((c, cIdx) => (
                          <tr key={cIdx} className="hover:bg-slate-900/50 transition">
                            <td className="p-3 font-bold text-purple-300">{c.subject}</td>
                            <td className="p-3 font-mono font-bold text-amber-400">{c.form}</td>
                            <td className="p-3 font-bold text-white">
                              <InteractiveText text={c.example} onWordClick={handleWordClick} />
                            </td>
                            <td className="p-3 text-slate-300 italic">{c.translation}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* PATRONES DE ESTRUCTURA (+ / - / ?) */}
              {topic.structures && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  {topic.structures.map((s, sIdx) => (
                    <div key={sIdx} className="bg-slate-900 p-3.5 rounded-xl border border-slate-800 space-y-1 text-xs">
                      <span className="text-[10px] font-black uppercase text-blue-400 block">{s.type}</span>
                      <p className="font-mono text-[11px] text-emerald-300 font-bold">{s.pattern}</p>
                      <p className="text-slate-300 font-medium italic mt-1">&quot;{s.example}&quot;</p>
                    </div>
                  ))}
                </div>
              )}

              {/* EJEMPLOS PRÁCTICOS */}
              {topic.examples && (
                <div className="space-y-2">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block">💬 Ejemplos Prácticos Bilingües:</span>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {topic.examples.map((ex, exIdx) => (
                      <div key={exIdx} className="bg-slate-900 p-3.5 rounded-xl border border-slate-800 space-y-1 text-xs">
                        <p className="font-bold text-white flex items-center gap-1.5">
                          <span className="text-blue-400">🇺🇸</span>
                          <InteractiveText text={ex.english} onWordClick={handleWordClick} />
                        </p>
                        <p className="text-slate-400 flex items-center gap-1.5 italic text-[11px]">
                          <span className="text-emerald-400">🇨🇴</span> {ex.spanish}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ALERTA PEDAGÓGICA TIP ICFES */}
              {topic.icfesTip && (
                <div className="bg-amber-950/70 border border-amber-500/40 p-4 rounded-xl flex items-start gap-3 shadow-md">
                  <span className="text-xl">💡</span>
                  <div className="space-y-0.5 text-xs">
                    <strong className="text-amber-300 uppercase tracking-wider text-[10px] block">Tip de Oro para Pruebas Saber ICFES:</strong>
                    <p className="text-amber-100 leading-relaxed font-medium">
                      {topic.icfesTip}
                    </p>
                  </div>
                </div>
              )}

            </div>
          ))}
        </div>

      </div>

      {/* EMERGENTE MODAL DE TRADUCCIÓN (SIN AUDIO) */}
      {activeWordData && (
        <div className="fixed inset-0 bg-slate-950/70 backdrop-blur-xs flex items-center justify-center p-4 z-50 animate-fadeIn">
          <div className="bg-slate-900 border border-blue-500/50 rounded-3xl max-w-sm w-full p-6 relative shadow-2xl space-y-4 text-left">
            <button 
              onClick={() => setActiveWordData(null)}
              className="absolute top-4 right-4 text-slate-400 hover:text-white font-bold text-lg bg-slate-800 w-7 h-7 rounded-full flex items-center justify-center transition cursor-pointer"
            >
              ✕
            </button>

            <div className="border-b border-slate-800 pb-3">
              <span className="text-[10px] font-bold uppercase tracking-wider text-blue-400 bg-blue-950 px-2 py-0.5 rounded-full border border-blue-500/30">
                {activeWordData.pos || 'Vocabulario'}
              </span>
              <h4 className="text-xl font-black text-white mt-1 capitalize">
                {activeWordData.word}
              </h4>
            </div>

            <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-1">
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Traducción en Español:</span>
              <p className="text-base font-bold text-emerald-400">{activeWordData.trans}</p>
            </div>

            <button
              onClick={() => setActiveWordData(null)}
              className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-2.5 rounded-xl transition text-xs shadow-lg cursor-pointer"
            >
              Entendido 👍
            </button>
          </div>
        </div>
      )}

    </div>
  );
}
